import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "/booking-meeting-room";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  room_meeting_type?: string;
};

export interface getRoomMeetingByTypeList extends listType {

}

export type booking_meeting_room_type_data = {
  meeting_room_name: string;
  meeting_room_start_date: string | null;
  meeting_room_end_date: string | null;
  meeting_room_start_time: string;
  meeting_room_end_time: string;
  meeting_room_desc: string;
  id_meeting_file_other: number | null;
  meeting_room_status: string;
  meeting_room_type: string;
  id_room_meeting: number | null;
};


export interface frontBookingMeetingRoomListType extends pagination_list {
  room_meeting_type?: string;
  sdate?: string;
  edate?: string;
  meeting_room_status?: string;
  keyword?: string;
}

export class BookingMeetingRoomApi extends BaseAPI {
  static createMeetingRoomByTypeList(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateMeetingRoomByTypeList(
    id_meeting_room: number,
    body: any
  ): Promise<any> {
    return this.api.patch(`${path}/${id_meeting_room}`, body);
  }

  static getMeetingRoomDetailById(id_meeting_room: number): Promise<any> {
    return this.api.get(`${path}/meeting-room/${id_meeting_room}`);
  }

  static getMyMeetingRoomDetail(query?: listType): Promise<any> {
    return this.api.get(`${path}/my-booking-room-list`, {
      params: { ...query },
    });
  }

  static getRoomMeetingByTypeList(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}/meeting-room-list`, {
      params: { ...query },
    });
  }

  static getRoomMeetingDetailById(id: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/room-meeting/${id}`);
  }

  static deleteMeetingRoomById(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }






  // NEWS NOT JOE DEV
  static frontBookingMeetingRoomList(params: frontBookingMeetingRoomListType): Promise<AxiosResponse> {
    return this.api.get(`${path}/my-booking-room-list`, { params })
  }
  static createBookingMeetingRoom(body: booking_meeting_room_type_data): Promise<AxiosResponse> {
    return this.api.post(`${path}`, body)
  }
  static updateBookingMeetingRoom(id_meeting_room: number, body: booking_meeting_room_type_data): Promise<AxiosResponse> {
    return this.api.patch(`${path}/${id_meeting_room}`, body)
  }
  static findOneBookingMeetingRoom(id_meeting_room: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/meeting-room/${id_meeting_room}`)
  }
  static deleteBookingMeetingRoom(id_meeting_room: number): Promise<AxiosResponse> {
    return this.api.delete(`${path}/${id_meeting_room}`)
  }
  static uploadFileBookingMeetingRoom(id_meeting_room: number, file: FormData): Promise<AxiosResponse> {
    return this.api.post(`${path}/${id_meeting_room}/upload-meeting-file`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static bookingCalendar(id_room_meeting?: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/meeting-room-list/calendar`, { params: { id_room_meeting } })
  }


}
